/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React Base Styles
import borders from "assets/theme-dark/base/borders";

// Material Dashboard 2 React Helper Functions
import pxToRem from "assets/theme-dark/functions/pxToRem";

const { borderRadius } = borders;

const cardMedia = {
  styleOverrides: {
    root: {
      // ✅ Coins arrondis accentués pour effet premium
      borderRadius: borderRadius.xl,

      // ✅ Marge bien espacée
      margin: `${pxToRem(16)} ${pxToRem(24)} 0`,

      // ✅ Image bien dimensionnée sans déformation
      objectFit: "cover",

      // ✅ Pleine largeur
      width: "100%",

      // ✅ Hauteur limitée pour équilibrer le design
      maxHeight: pxToRem(180),
    },

    media: {
      // ✅ Image responsive (adaptable)
      width: "100%",
    },
  },
};

export default cardMedia;
